/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { useParams } from 'react-router-dom';
import { validate as uuidValidate } from 'uuid';

import { HTTPError } from '@/components/HTTPError';
import { UserDetailsPage } from '@/pages/UserDetails/UserDetailsPage';

export function UserDetailsRoute() {
  const { userID } = useParams<'userID'>();

  if (!userID || !uuidValidate(userID)) {
    return <HTTPError httpStatus="404" />;
  }

  return <UserDetailsPage userId={userID} />;
}
